const prefix = '@@current_user';

const LOGGED_OUT = `${prefix}/LOGGED_OUT`;

export {
    LOGGED_OUT,
};
